import { useCallback } from "react";
import { useSelector } from "react-redux";
import {
  usePatchCollaboratorMutation,
  usePatchProfileMutation,
} from "../redux/appSlices/collaborator/collaboratorApiSlice";
import { getActiveProfilePatchTarget } from "../utils/profilePicture";

const useActiveProfilePatch = () => {
  const collaborator = useSelector(
    (state) => state.collaborator.collaboratorInfo,
  );
  const [patchCollaborator, patchCollaboratorState] =
    usePatchCollaboratorMutation();
  const [patchProfile, patchProfileState] = usePatchProfileMutation();

  const patchActiveProfile = useCallback(
    ({ content }) => {
      const target = getActiveProfilePatchTarget(collaborator);
      if (!target) {
        return Promise.reject(new Error("Missing collaborator patch target"));
      }

      if (target.type === "collaborator") {
        return patchCollaborator({ id: target.id, content });
      }

      return patchProfile({ id: target.id, content });
    },
    [collaborator, patchCollaborator, patchProfile],
  );

  return [
    patchActiveProfile,
    {
      isLoading:
        patchCollaboratorState.isLoading || patchProfileState.isLoading,
      isError: patchCollaboratorState.isError || patchProfileState.isError,
      isSuccess:
        patchCollaboratorState.isSuccess || patchProfileState.isSuccess,
    },
  ];
};

export default useActiveProfilePatch;
